import dayjsLib from "dayjs"
import "dayjs/locale/en"
import "dayjs/locale/ru"
import "dayjs/locale/uk"
import duration from "dayjs/plugin/duration"
import utc from "dayjs/plugin/utc"
import i18n from "i18next"

dayjsLib.extend(utc)
dayjsLib.extend(duration)

dayjsLib.locale(i18n.language)
i18n.on("languageChanged", (lng) => dayjsLib.locale(lng))

export const dayjs = dayjsLib

/**
 * Milliseconds remaining until the NEXT local-midnight (start of tomorrow).
 * Used by `useMidnightTick` to schedule a re-render so date-labels like
 * "today" / "yesterday" roll over even while the tab is left open overnight.
 */
export const msUntilNextLocalMidnight = (): number => {
  const nextMidnight = dayjsLib().add(1, "day").startOf("day")
  return nextMidnight.valueOf() - Date.now()
}
